import { useDisclosure } from '@chakra-ui/react'
import { useAppCookies } from '@!/Hooks'
import MonthlyCourseErrorCancelledDialog from '@!/Store/Purchase/components/MonthlyCourseErrorCancelledDialog'
import { ConfirmPopupModal } from '@!/components/Modal'

const MonthlyCourseErrorCancelledDialogContainer = ({ monthlyErrorCancelledCourses }) => {
  const { monthlyCourseErrorCancelledOrderIdsCookie, setMonthlyCourseErrorCancelledOrderIdsCookie } = useAppCookies()
  const { isOpen: isOpenDialog, onClose: closeDialog } = useDisclosure({
    defaultIsOpen:
      monthlyErrorCancelledCourses && monthlyErrorCancelledCourses.some((c) => !(monthlyCourseErrorCancelledOrderIdsCookie || []).includes(c.order_id)),
  })
  const { isOpen: isOpenConfirmModal, onOpen: openConfirmModal, onClose: closeConfirmModal } = useDisclosure()

  const handleDialogClose = () => {
    if (isOpenDialog) {
      // ダイアログを閉じた際に、同じエラーメッセージを再度表示しないよう対象の order_id を Cookie に保存する。
      // 新しくキャンセルされたコースがあれば再度ダイアログを表示する。
      const orderIds = monthlyErrorCancelledCourses.map((c) => c.order_id)
      setMonthlyCourseErrorCancelledOrderIdsCookie(orderIds)
    }
    closeDialog()
    openConfirmModal()
  }

  return (
    <>
      <MonthlyCourseErrorCancelledDialog isOpen={isOpenDialog} onClose={handleDialogClose} cancelledCourses={monthlyErrorCancelledCourses} />
      <ConfirmPopupModal
        text={`月額履歴ページで決済エラーのコースをご確認いただけます。\n「再登録」ボタンよりお手続きください。`}
        handlePopup={closeConfirmModal}
        isOpen={isOpenConfirmModal}
      />
    </>
  )
}

export default MonthlyCourseErrorCancelledDialogContainer
